<template>
    <b-overlay :show="loading" rounded="sm">

        <b-card v-if="essay" class="mb-3">
            <template #header>
                <div class="d-flex justify-content-between">


                    <div class="d-flex align-items-center gap-2 ">
                        Áudios
                        <span v-b-tooltip.hover title="Aqui você pode comentar por áudio sobre o texto do aluno">
                            <svg xmlns="http://www.w3.org/2000/svg" class="icons" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" >
                                <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                            </svg>
                        </span>
                        <span class="badge bg-warning " v-b-tooltip.hover title="Agora você pode definir categorias para os áudios em configurações, após gravar clique nos três pontos.">
                            Novo
                        </span>
                    </div>
                </div>
            </template>
            <div class="alert alert-info alert-dismissible" role="alert">
                Áudios possuem limite de 5 minutos por gravação.
            </div>

            <div class="mb-2" v-if="withoutCategoryAudios.length !== 0">
                <div class="pb-2 border-bottom" v-if="withoutCategoryAudios.length !== 0 && withCategoryAudios.length !== 0" >Sem categoria</div>
                <div class="py-2 px-3 bg-light text-black-50" v-if="withoutCategoryAudios.length === 0">
                    Nada por aqui...
                </div>
                <div v-for="essay_audio in withoutCategoryAudios" :key="essay_audio.id">
                    <div class="py-2 d-flex align-items-center justify-content-between">
                        <audio v-if="essay_audio.converted_preview" class="d-flex audio m-0 p-0" controls>
                            <source v-if="essay_audio.converted_preview" :src="essay_audio.converted_preview" />
                            <source v-if="essay_audio.original_preview" :src="essay_audio.original_preview" />
                        </audio>
                        <div v-else class="py-2 px-2 d-flex align-items-center text-muted">
                            <b-spinner variant="gray" small label="processando ..." class="mr-2"/> processando áudio ...
                        </div>
                        <div v-if="canEdit" class="ml-1 dropdown">
                            <button role="button" class="btn btn-sm btn-light" data-bs-toggle="dropdown" id="dropdownCategory">
                                <svg xmlns="http://www.w3.org/2000/svg" class="icons" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                                v-b-tooltip.hover title="Mudar Categoria">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z" />
                                </svg>
                            </button>

                            <ul class="dropdown-menu" aria-labelledby="dropdownCategory">
                                <li class="dropdown-text"></li>
                                <li v-for="audio_category in audioCategories" :key="audio_category.id" >
                                    <span class="dropdown-item" @click="onClickUpdateAudioCategory(audio_category.id, essay_audio.id)">{{audio_category.name}}</span>
                                </li>
                            </ul>

                        </div>
                        <a v-if="canEdit" href="javascript:void(1);" class="ml-2 d-flex" @click="destroy(essay_audio.id)">
                            <span class="fas fa-trash text-danger"></span>
                        </a>
                    </div>

                </div>
            </div>

            <div class="mb-2">
                
                <div v-for="category in withCategoryAudios" :key="category.id">
                    <div class="pb-2 border-bottom">{{ category.name}}</div>
                    <div v-for="essay_audio in category.essay_audios" :key="essay_audio.id">
                        <div class="py-2 d-flex align-items-center justify-content-between">
                            <audio v-if="essay_audio.converted_preview" class="d-flex audio m-0 p-0" controls>
                                <source v-if="essay_audio.converted_preview" :src="essay_audio.converted_preview" />
                                <source v-if="essay_audio.original_preview" :src="essay_audio.original_preview" />
                            </audio>
                            <div v-else class="py-2 px-2 d-flex align-items-center text-muted">
                                <b-spinner variant="gray" small label="processando ..." class="mr-2"/> processando áudio ...
                            </div>
                            <div v-if="canEdit" class="ml-1 dropdown">
                                <button role="button" class="btn btn-sm btn-light" data-bs-toggle="dropdown" id="dropdownCategory">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="icons" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                                    v-b-tooltip.hover title="Mudar Categoria">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z" />
                                    </svg>
                                </button>

                                <ul class="dropdown-menu" aria-labelledby="dropdownCategory">

                                    <li v-for="audio_category in audioCategories" :key="audio_category.id" >
                                        <span class="dropdown-item" @click="onClickUpdateAudioCategory(audio_category.id, essay_audio.id)">{{audio_category.name}}</span>
                                    </li>
                                    <li class="dropdown-item text-danger" @click="onClickUpdateAudioCategory(null, essay_audio.id)">remover categoria</li>
                                </ul>

                            </div>
                            <a v-if="canEdit" href="javascript:void(1);" class="ml-2 d-flex" @click="destroy(essay_audio.id)">
                                <span class="fas fa-trash text-danger"></span>
                            </a>
                        </div>

                    </div>
                </div>
            </div>

            <div class="py-2 px-3 bg-light text-muted" v-if="essay_audios.length === 0">
                Não há áudios gravados :(
            </div>
            <!--

                <div v-for="essay_audio in essay_audios" :key="essay_audio.id">
                    <div class="py-2 d-flex align-items-center justify-content-between">
                        <audio v-if="essay_audio.converted_preview" class="d-flex audio m-0 p-0" controls>
                            <source v-if="essay_audio.converted_preview" :src="essay_audio.converted_preview" />
                            <source v-if="essay_audio.original_preview" :src="essay_audio.original_preview" />
                        </audio>
                        <div v-else class="py-2 px-2 d-flex align-items-center text-muted">
                            <b-spinner variant="gray" small label="processando ..." class="mr-2"/> processando áudio ...
                        </div>
                        <div v-if="canEdit" class="ml-1 dropdown">
                            <button role="button" class="btn btn-sm btn-light" data-bs-toggle="dropdown" id="dropdownCategory">
                                <svg xmlns="http://www.w3.org/2000/svg" height="1.5em" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6"
                                v-b-tooltip.hover title="Mudar Categoria">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z" />
                                </svg>
                            </button>

                            <ul class="dropdown-menu" aria-labelledby="dropdownCategory">
                                <li class="dropdown-text"></li>
                                <li v-for="audio_category in audioCategories" :key="audio_category.id" >
                                    <span class="dropdown-item" @click="onClickUpdateAudioCategory(audio_category.id, essay_audio.id)">{{audio_category.name}}</span>
                                </li>
                            </ul>

                        </div>
                        <a v-if="canEdit" href="javascript:void(1);" class="ml-2 d-flex" @click="destroy(essay_audio.id)">
                            <span class="fas fa-trash text-danger"></span>
                        </a>
                    </div>
                </div>
            -->

            <div v-if="canEdit" class="mt-2 font-weight-bold">

                <div class="py-2 px-1 border rounded text-center mb-3" v-if="recording || action === 'PAUSE'">
                    {{ calculateTimeDuration }}
                </div>

                <div class="py-2" v-if="uploadProgress">
                    <b-progress :max="100">
                        <b-progress-bar :value="uploadProgress" :label="`${((uploadProgress / 100) * 100).toFixed(2)}%`" animated></b-progress-bar>
                    </b-progress>
                </div>

                <b-button-group>
                    <b-button @click="startRecording" v-if="!record && !recording && !action" variant="outline-danger" size="sm">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="audio-icon">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M12 18.75a6 6 0 006-6v-1.5m-6 7.5a6 6 0 01-6-6v-1.5m6 7.5v3.75m-3.75 0h7.5M12 15.75a3 3 0 01-3-3V4.5a3 3 0 116 0v8.25a3 3 0 01-3 3z" />
                        </svg>

                        Iniciar Gravação
                    </b-button>
                    <b-button @click="pauseRecording" v-if="recording" variant="outline-secondary" size="sm">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="audio-icon" >
                            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 5.25v13.5m-7.5-13.5v13.5" />
                        </svg>

                        Pausar Gravação
                    </b-button>
                    <b-button @click="resumeRecording" v-if="!record && !recording && (action && action === 'PAUSE')" variant="outline-secondary" size="sm">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="audio-icon">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.348a1.125 1.125 0 010 1.971l-11.54 6.347a1.125 1.125 0 01-1.667-.985V5.653z" />
                        </svg>

                        Retomar Gravação
                    </b-button>
                    <b-button @click="stopRecording" v-if="recording" variant="outline-success" size="sm">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="audio-icon">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                        </svg>

                        Concluir Gravação
                    </b-button>
                </b-button-group>
            </div>
        </b-card>
    </b-overlay>

</template>

<script>
import * as RecordRTC from 'recordrtc';


export default {

    props: ['essay'],

    data() {
        return {
            loading: false,
            canEdit: true,
            essay_audios: [],
            record: false,
            recording: false,
            audio: null,
            recordRTC: null,
            stream: null,
            canRecord: false,
            action: null,
            uploadProgress: null,
            loadIntervalTime: 5000,
            loadInterval: null,
            seconds: 0,
            secondsInstance: null,
            secondsLimit: 300,

            audioCategories: [],
            withCategoryAudios: [],
            withoutCategoryAudios:[],
        }
    },

    computed: {
        calculateTimeDuration() {
            const secs = this.seconds;

            let hr = Math.floor(secs / 3600);
            let min = Math.floor((secs - (hr * 3600)) / 60);
            let sec = Math.floor(secs - (hr * 3600) - (min * 60));

            if (min < 10) {
                min = "0" + min;
            }

            if (sec < 10) {
                sec = "0" + sec;
            }

            if(hr <= 0) {
                return min + ':' + sec;
            }

            return hr + ':' + min + ':' + sec;
        }
    },

    created() {
        if (this.essay.status === 'OKAY' || this.essay.status === 'WAIT' || this.essay.status === 'BLOCK'){
            this.canEdit = false;
        }

        this.secondsInstance = setInterval(this.intervalCheck.bind(this), 1000);

        this.load()
        this.getCategories()

        this.loadInterval = setInterval(() => {
            this.load(false)

        }, this.loadIntervalTime)
    },

    destroyed() {
        clearInterval(this.loadInterval)
        clearInterval(this.secondsInstance)
    },

    methods: {

        onClickUpdateAudioCategory(categoryId, audioId){
            axios.put(`/teacher/essay-audios/${audioId}`, {
                essay_audio_category_id: categoryId
            })
            .then((result)=>{
                this.load()
            })
        },

        getCategories(){
            this.loading = true
            axios.get('/teacher/essay-audio-categories')
            .then((result)=>{
                const response = result.data.data.categories

                this.audioCategories = response

            })
            .finally(()=>{
                this.loading= false
            })
        },

        load(loading = true) {
            if (loading) {
                this.loading = true;
            }

            axios.get('/teacher/essay-audios/' + this.essay.id)
                .then((result) => {
                    this.essay_audios = result.data.data.essay_audios;

                    let withCategoryAudios = []
                    let withoutCategoryAudios = []


                    this.essay_audios.forEach((audio)=>{
                        if(audio.essay_audio_category_id){

                            if(!withCategoryAudios.find(cate=> cate.id === audio.essay_audio_category_id )){
                                withCategoryAudios.push({...audio.essay_audio_category, essay_audios: []})

                            }
                            withCategoryAudios.forEach((cate, index)=> {
                                if(audio.essay_audio_category_id === cate.id){
                                    withCategoryAudios[index].essay_audios.push({...audio})
                                }
                            })
                        }
                        else{

                            withoutCategoryAudios.push(audio)
                        }

                    })
                    this.withCategoryAudios = withCategoryAudios
                    this.withoutCategoryAudios = withoutCategoryAudios


                })
                .finally(() => {
                    if (loading) {
                        this.loading = false
                    }
                })
        },

        destroy(id) {
            this.$bvModal.msgBoxConfirm('Deseja realmente apagar esse áudio ?', {
                cancelTitle: 'Cancelar',
                okTitle: 'Quero apagar esse áudio',
                cancelVariant: 'default',
                okVariant: 'danger'
            }).then(answer => {
                if (answer) {
                    this.loading = true;
                    axios.delete('/teacher/essay-audios/' + id)
                        .then((result) => {
                            this.$toast.success('Áudio deletado com sucesso :)')

                            this.load();
                        })
                        .finally(() => this.loading = false)
                }
            })
        },

        intervalCheck() {
            if (this.recording) {
                if(this.seconds === this.secondsLimit){
                    this.stopRecording()
                    this.$toast.info('O limite de tempo de áudio foi atingido, a gravação será finalizada.')
                }
                this.seconds++;
            }
        },

        async getPermission() {
            try {
                await navigator
                    .mediaDevices
                    .getUserMedia({
                        audio: true,
                    })
                    .then(
                        this.successCallback.bind(this),
                        this.errorCallback.bind(this)
                    );
            } catch (error) {
                this.$toast.error('Não conseguimos autorização para acessar o microfone de seu computador :(');
            }
        },

        successCallback(stream) {
            this.stream = stream;

            this.recordRTC = RecordRTC(stream, {
                type: 'audio'
            });

            this.canRecord = true;
            this.record = false;
            this.recording = false;
        },

        errorCallback(err) {
            this.$toast.error('Não conseguimos autorização para acessar o microfone de seu computador :(')
            this.canRecord = false;
            this.record = false;
            this.recording = false;
        },

        async trashRecord() {
            this.stream = null;
            this.recordRTC = null;
            this.recording = false;
            this.record = false;
            this.action = null;
            this.seconds = 0;
            this.secondsInstance = null;
        },

        async startRecording() {
            if (! this.recordRTC) {
                await this.getPermission();
            }

            try {
                if (this.recordRTC) {
                    await this.recordRTC.startRecording();

                    this.action = 'START';
                    this.recording = true;
                }
            } catch (error) {

                this.$toast.error('Não conseguimos iniciar a gravação :( Entre em contato com o suporte para ajudarmos você :)')
            }
        },

        pauseRecording() {
            this.recordRTC.pauseRecording();
            this.action = 'PAUSE';
            this.record = false;
            this.recording = false;
        },

        resumeRecording() {
            this.recordRTC.resumeRecording();
            this.action = 'RESUME';
            this.record = false;
            this.recording = true;
        },

        async stopRecording() {

            this.seconds = 0;

            this.uploadProgress = 0;

            // Get Blob
            await this.recordRTC.stopRecording(async (dataBlob) => {

                const response = await fetch(dataBlob);
                const blob = await response.blob();

                let extension = '.webm';
                if (blob.type === 'audio/ogg') {
                    extension = '.ogg';
                }
                if (blob.type === 'audio/mp4') {
                    extension = '.mp4';
                }

                const audioFile = new File(
                    [blob],
                    'audio.' + extension,
                    {
                        type: blob.type
                    }
                );

                // Send to S3
                await Vapor.store(audioFile, {
                    progress: progress => {
                        this.uploadProgress = Math.round(progress * 100);
                    }
                })
                    .then(async response => {

                        this.loading = true;

                        // Save in Disk Reference
                        await axios.post('/save-file-in-disk', {
                            success: true,
                            uuid: response.uuid,
                            key: response.key,
                            bucket: response.bucket,
                            extension: response.extension,
                            path: '/audios',
                            name: audioFile.name,
                            size: audioFile.size,
                        })
                            .then(async response => {
                                // Add Audio in Essay
                                await axios.post('/teacher/essay-audios/' + this.essay.id, response.data)
                                    .then(async (result) => {

                                        // Save Message
                                        this.$toast.success('O áudio foi salvo :)', {
                                            duration: 1500
                                        })

                                        // Load
                                        await this.load()

                                        // Get Permissions
                                        this.recordRTC = null;
                                        this.stream = null;
                                        this.recording = false;
                                        this.record = false;

                                        // Action Default
                                        this.action = null;
                                    })
                                    .catch(error => {
                                        this.$toast.error('Houve um erro tentar atribuir o áudio a redação :(')
                                    })
                                    .finally(() => this.loading = false)
                            })
                            .catch(error => {
                                this.$toast.error('Houve um erro tentar salvar o áudio na plataforma :(')
                                this.loading = false;
                            })
                    })
                    .catch((error) => {
                        this.$toast.error('Houve um erro tentar enviar o áudio para o servidor de arquivos :(')
                        this.loading = false;
                    })
                    .finally(() => {
                        this.uploadProgress = null;
                    })
            });

            this.action = 'STOP';
            this.stream.getAudioTracks().forEach(track => track.stop());

            this.record = false;
            this.recording = false;
        },

        saveRecording() {
            this.loading = true;

            const recordedBlob = this.recordRTC.getDataURL((dataURL) => {

            });
            this.load()
        }
    }
}
</script>

<style scoped>
    .icons{
        height: 20px;
    }
    .audio {
        width: 100%;
    }
    .audio-icon {
        width: 20px;
    }
    .audio-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
    }
</style>
